import moment from "moment"

export const timeLapsedFromNow = (date : Date) => moment(date).fromNow()
export const getDate = (date? : Date) => !date ? undefined : moment(date).toDate()
export const formatDate = (date? : Date) => !date ? undefined : moment(date).format('YYYY-MM-DD').trim();
export const getDateFromMongoId = (id? : string) => (!id || (id.length < 7)) ? undefined : new Date(parseInt(id.substring(0, 8), 16) * 1000);